import classnames from 'classnames'
import { css } from 'emotion'

import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'

import Wrapper from '../Wrapper'

const styles = require('embed/styles/application')
const InfoIcon = require('../../info-blue.svg')

export interface Props {
  backToSearch?: boolean
  children?: React.ReactNode
  directReferral?: boolean
  disableCTA?: boolean
  dispatchBackToStepOne: () => void
  getOffersCta?: boolean
  handleConsentsToFCRAandTCPA?: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  selectedVariantId?: string
}

const StepbystepApplicationStepSocialSecurity: React.SFC<Props> = (props) => (
  <ThemeConsumer>
    {({ colorPrimary }) => (
      <Wrapper {...props}>
        <StepTitle>What’s your social security number?</StepTitle>
        <ApplicationField product={Product.Loan} field={Fields.SocialSecurityNumber} onEnter={props.onEnter}>
          <div
            className={classnames(
              styles.creditScore,
              css`
                color: ${colorPrimary};
                svg path {
                  fill: ${colorPrimary};
                }
              `,
            )}
          >
            <InfoIcon />
            <em
              className={css`
                margin: auto 0px;
              `}
            >
              This will NOT affect your credit score
            </em>
          </div>
        </ApplicationField>
      </Wrapper>
    )}
  </ThemeConsumer>
)

export default StepbystepApplicationStepSocialSecurity
